import {put} from "redux-saga/effects";
import SagaRunnable from "../generics/SagaRunnable";
import ComponentStateModel from "../generics/ComponentStateModel";
import JobQueueModel from "../job/JobQueueModel";
import GuidedJobModel from "../guidedjob/GuidedJobModel";
import {jobPageViewKeys} from "../../i18next/keys";
import JobModel from "../job/JobModel";
import VaultCache from "../guidedjob/VaultCache";

class JobVaultModel {

    static componentActionCreators = {
        ...JobVaultModel.buildComponentSetActiveActionCreators()
    };

    static buildComponentSetActiveActionCreators() {
        const components = [
            {
                key: 'JOB_VAULT_DISPLAY',
                type: 'Display'
            }
        ];
        return ComponentStateModel.buildSetActiveActionCreators(...components);
    }
}

export class JobVaultSaga extends SagaRunnable {

    static activationComponent = 'JOB_VAULT_DISPLAY';

    static buildActivationEffects(dispatch) {
        return [
            put(JobQueueModel.componentActionCreators.setDisplayActive()),
            put(GuidedJobModel.componentActionCreators.setDisplayActive())
        ]
    }

    static buildDeactivationEffects() {
        return [
            put(JobQueueModel.componentActionCreators.setDisplayInactive()),
            put(GuidedJobModel.componentActionCreators.setDisplayInactive()),
            put(VaultCache.actionCreators.reset())
        ]
    }

    static* setInstanceId(args) {
        yield put(JobModel.componentActionCreators.updatePage({activeView: jobPageViewKeys.VAULT, jobId: args.id}));
    }
}

export default JobVaultModel;
